import { DataProps } from '../types';

export const getChildRows = (
  parentRow: DataProps,
  dataRows: DataProps[]
): DataProps[] | never[] | null => {
  const childRows = dataRows.filter(
    (row) => row.parentRowId === (parentRow ? parentRow.rowId : '')
  );
  if (childRows.length) {
    return childRows;
  }

  return parentRow && !parentRow.parentRowId ? [] : null;
};
